import type { Story } from '@/store/story-types'

export const CREATOR_DIGITAL_SHOP_STORY: Story = {
  id: 'creator-digital-shop',
  name: 'STUDIO - Digital Products',
  narrative:
    'A creator digital products store for selling e-books, templates, presets, and courses with a clean storefront and full shopping flow.',
  goals: [
    'Present creator brand and digital product catalog',
    'Enable product detail viewing with previews',
    'Provide cart management and checkout',
    'Confirm orders with clear confirmation page',
    'Support multiple digital product types',
  ],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'home',
      description:
        'Storefront landing with creator hero and product grid',
      blockRef: { category: 'store', blockId: 'creator-hero' },
    },
    {
      id: 'pg-product-detail',
      title: 'Product Detail',
      order: 1,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'product-detail',
      description: 'Digital product detail with preview, description, and purchase button',
      blockRef: { category: 'store', blockId: 'product-detail' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 2,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'cart',
      description: 'Shopping cart with digital items and order total',
      blockRef: { category: 'store', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout',
      title: 'Checkout',
      order: 3,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'checkout',
      description: 'Checkout form with payment and order summary',
      blockRef: { category: 'store', blockId: 'checkout' },
    },
    {
      id: 'pg-order-confirmation',
      title: 'Order Confirmed',
      order: 4,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'order-confirmation',
      description: 'Order confirmation with download links and summary',
      blockRef: { category: 'store', blockId: 'order-confirmation' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-browse',
      name: 'Browse Digital Catalog',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        {
          type: 'then',
          text: 'the creator hero and product grid with digital items are visible',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-view-product',
      name: 'View Product Detail',
      steps: [
        { type: 'given', text: 'the visitor is browsing the product grid' },
        { type: 'when', text: 'the visitor taps on a digital product card' },
        {
          type: 'then',
          text: 'the product detail page shows preview, description, price, and purchase button',
          linkedPageId: 'product-detail',
        },
      ],
    },
    {
      id: 'bdd-add-to-cart',
      name: 'Add Product to Cart',
      steps: [
        { type: 'given', text: 'the visitor is viewing a product detail page' },
        { type: 'when', text: 'the visitor taps "Add to Cart"' },
        {
          type: 'then',
          text: 'the product is added to the cart and the cart badge updates',
          linkedPageId: 'cart',
        },
      ],
    },
    {
      id: 'bdd-checkout',
      name: 'Complete Checkout',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart' },
        { type: 'when', text: 'the visitor proceeds to checkout and completes payment' },
        {
          type: 'then',
          text: 'the order is confirmed and download links are provided',
          linkedPageId: 'order-confirmation',
        },
      ],
    },
  ],
}
